module.exports = __webpack_public_path__ + "img/tbc-bfr.ccae5c0e.jpg";